import {NetworkAPIVersion} from './network.utils';

export default {
  getMigrationDestination: {
    url: 'migration-destination/{place_id}/',
    method: 'get',
    apiVersion: NetworkAPIVersion.v1_version,
  },
};
